import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';

export default function getFirstNodeIdToShow(nodeIds: string[]): string {
    for (const nodeId of nodeIds) {
        if (getItemToShowFromNodeId(nodeId)) {
            return nodeId;
        }
    }
    return null;
}
